
import React, { useState } from "react";

import { Grid, Tooltip, Typography, Menu, MenuItem, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TagColors from "../../../utility/TagColors";

const IncomingOrderState = ({ incomingOrder, updateIncomingOrderState, reload, state, isDisabled }) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateState = async (state) => {
    try {
      const res = await updateIncomingOrderState(incomingOrder.id, state);
      await reload();
    } catch (err) {
      console.log(err);
    }
  };

  const statusSource = state.map(e => ({title: e.name, value: e.id, tag: e.tag }));

  const selectedStatus = statusSource.find((status) => status.value === incomingOrder.stateId);
  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ color: TagColors[selectedStatus.tag]}}
        disabled={isDisabled}
      >
        {selectedStatus.title}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {statusSource.map((state) => (
          <MenuItem
            key={state.value}
            onClick={() => {
              updateState(state.value);
              handleClose();
            }}
            style={{
              backgroundColor: TagColors[state.tag]
            }}
          >
            {state.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default IncomingOrderState;